import { object, string } from "yup";

export const addHolidaySchema = object({
  date: string().required("Please select a date"),
  timezone: string().required("Please select a timezone"),
});
